import React from "react";
import CrudModule from "@/components/admin/CrudModule";
import { Badge } from "@/components/common/Primitives";
import { sponsorsCrud } from "@/services/sponsorsService";
import { storageService } from "@/services/storageService";
import { sponsorCategories } from "@/data/seed/sponsors";

export default function AdminSponsorsPage() {
  return (
    <CrudModule
      title="Sponsors"
      description="Businesses and well-wishers showcased on the Sponsors page and homepage."
      crud={sponsorsCrud}
      searchKeys={["name", "business_name", "category", "tier"]}
      columns={[
        { key: "name", label: "Sponsor" },
        { key: "category", label: "Category" },
        { key: "tier", label: "Tier", render: (r) => <Badge tone="gold">{r.tier}</Badge> },
        { key: "sort_order", label: "Order" },
      ]}
      toggles={[
        { key: "is_published", label: "Published" },
        { key: "is_featured", label: "Featured" },
      ]}
      fields={[
        { name: "name", label: "Sponsor Name", type: "text", required: true },
        { name: "business_name", label: "Business Name", type: "text" },
        { name: "category", label: "Category", type: "select", options: sponsorCategories.filter((c) => c !== "All"), required: true },
        { name: "tier", label: "Tier", type: "select", options: ["Platinum", "Gold", "Silver", "Best Compliments"], required: true },
        {
          name: "logo_url",
          label: "Logo",
          type: "image",
          onUpload: (file, hint) => storageService.uploadSponsorLogo(file, hint),
          folderLabel: "sponsors",
          nameHintFrom: "name",
        },
        { name: "website", label: "Website", type: "text" },
        { name: "phone", label: "Phone", type: "text" },
        { name: "email", label: "Email", type: "text" },
        { name: "souvenir_page", label: "Souvenir Page No.", type: "number" },
        { name: "sort_order", label: "Sort Order", type: "number" },
        { name: "description", label: "Description", type: "textarea" },
        { name: "is_published", label: "Published", type: "checkbox", default: true },
        { name: "is_featured", label: "Featured", type: "checkbox", default: false },
      ]}
    />
  );
}
